export default __webpack_public_path__ + "static/media/haunted-house-foreground.f7c0795f.png";